import KofiErfassungPositionBaseMixin from "./KofiErfassungPositionBaseMixin";

// @vue/component
export default {
  name: "KofiErfassungPosition",
  mixins: [
    KofiErfassungPositionBaseMixin,
  ],
};
